import { Logger, SupportedProducts } from 'atp-api-logger';

import { isProductionEnv } from '@/_static/constants';

export const logger = Logger.getInstance(SupportedProducts.LQ, isProductionEnv);
